module.exports = __webpack_public_path__ + "img/no-data.0fd41765.png";